import OpenPanelFilledLeft20 from '@carbon/icons-react/es/open-panel--filled--left/20';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { StyledSidebarToggleButton } from 'components/organisms/spaces/space-tab/styles';
import { useTranslation } from 'hooks/use-translation';

interface SidebarCollapseButtonProps {
  sidebarToggle: () => void;
}

export const SidebarCollapseButton: FC<SidebarCollapseButtonProps> = ({
  sidebarToggle,
}) => {
  const sidebarCollapseText = useTranslation('collapse_sidebar');

  return (
    <Tooltip title={sidebarCollapseText} trigger={['hover']}>
      <StyledSidebarToggleButton
        type="text"
        size="small"
        onClick={sidebarToggle}
      >
        <OpenPanelFilledLeft20 color="var(--blue-60)" />
      </StyledSidebarToggleButton>
    </Tooltip>
  );
};
